import { render, staticRenderFns } from "./PengajuanIjin.vue?vue&type=template&id=3c66d55b&scoped=true"
import script from "./PengajuanIjin.vue?vue&type=script&lang=js"
export * from "./PengajuanIjin.vue?vue&type=script&lang=js"
import style0 from "./PengajuanIjin.vue?vue&type=style&index=0&id=3c66d55b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c66d55b",
  null
  
)

export default component.exports